module.exports = __webpack_public_path__ + "static/img/1000000438_green.627d405c.jpg";